export default {
    app: {
        drawerTitle: process.env.VUE_APP_DRAWER_TITLE,
        title: process.env.VUE_APP_TITLE,
        shortTitle: process.env.VUE_APP_SHORT_TITLE,
        icon: 'language',
        appKey: process.env.VUE_APP_KEY
    },

    user: {
        id: null,
        name: null,
        email: null,
        role: null,
        permissions: null,
        access_token: null,
        last_seen: null,
    },

    app_settings: {
        dt_invoices: {
            items_per_page: 10,
            columns: [],
        },

        dt_telemetry: {
            items_per_page: 10,
            columns: []
        },

        dt_exports: {
            items_per_page: 10,
            columns: []
        },

        dt_cashier_maintenances: {
            items_per_page: 10,
            columns: []
        },

        dt_maintenances: {
            items_per_page: 10,
            columns: []
        },

        invoices: {
            filter_results_open: true
        },

        telemetry: {
            filter_results_open: true,
            map_open: true,
            active_alarm: true,
            offline_devices: false,
            selected_cashiers: [],
            selected_locations: []
        },

        maintenances: {
            filter_results_open: true
        }
    },

    authenticated: false,

    drawer: null,
    loader: false,
    progress: false,
    loaderText: '',
    toolbarTitle: '',
    search: '',
    searchFieldState: false,
    mobileSearch: false,

    snackbar: {
        display: false,
        y: 'bottom',
        x: 'left',
        mode: '',
        timeout: 7000,
        text: 'Hello, I\'m a snackbar'
    },

    access_log: [],
    currentRoute: null,

    parameters_data: null
}